import { render, staticRenderFns } from "./CXDeposit.vue?vue&type=template&id=e6dea79c"
import script from "./CXDeposit.vue?vue&type=script&lang=js"
export * from "./CXDeposit.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports